/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        // JavaScript to be fired on all pages

        // Gallery Lightbox
        $(document).ready(function () {
          $('.popup-gallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
              enabled: true,
              navigateByImgClick: true,
              preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
            },
          });
        });


        function setPPCData() {
          var params = new URL(document.location).searchParams;

          var source = params.get("utm_source");
          var medium = params.get("utm_medium");
          var campaign = params.get("utm_campaign");
          var content = params.get("utm_content");

          if(window.sessionStorage && !window.sessionStorage.getItem('source')){
            if(source != null){
              sessionStorage.source = source;
            }
          }

          if(window.sessionStorage && !window.sessionStorage.getItem('medium')){
            if(medium != null){
              sessionStorage.medium = medium;
            }
          }

          if(window.sessionStorage && !window.sessionStorage.getItem('campaign')){
            if(campaign != null){
              sessionStorage.campaign = campaign;
            }
          }

          if(window.sessionStorage && !window.sessionStorage.getItem('content')){
            if(content != null){
              sessionStorage.content = content;
            }
          }
        }


        $(window).load(function(){
          setPPCData();
        });

      /**
      * Init magnificPopup video modal
      */
      $('.video-popup a').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
      });

        /**
         * Sets the fixed class once page has scrolled past header.
         */
        function fxiedNavigation(scrollTop){
          var bannerHeight = $('header.banner').height();
          if (scrollTop > bannerHeight) {
            $('.flex-nav').addClass('fixed');
            $('.hamburger').addClass('fixed');
            }else {
              $('.flex-nav').removeClass('fixed');
              $('.hamburger').removeClass('fixed');
            }
          }

        // Init fixedNavigation function on scroll
        $(window).scroll(function() {
          var scrollTop = $(window).scrollTop();
            fxiedNavigation(scrollTop);
        });

        // Init fixedNavigation function on load
        $(window).load(function() {
          var scrollTop = $(window).scrollTop();
          fxiedNavigation(scrollTop);
        });

        //Cookie Consent
        window.addEventListener("load", function() {
          var languageCode = $("html").attr("lang");
          if (languageCode === "cy-GB") {
            window.cookieconsent.initialise({
              palette: {
                popup: {
                  background: "#000"
                },
                button: {
                  background: "#241D4F"
                }
              },
              position: "bottom-left",
              content: {
                message: "Mae'r wefan hon yn defnyddio cwcis i sicrhau eich bod yn cael y profiad gorau ar ein gwefan.",
                dismiss: "Lawn!",
                link: "Rhagor o wybodaeth",
                href: window.location.origin + "/cy/cookies-policy"
              }
            });
          } else {
            window.cookieconsent.initialise({
              palette: {
                popup: {
                  background: "#000"
                },
                button: {
                  background: "#241D4F"
                }
              },
              position: "bottom-left",
              content: {
                message: "This website uses cookies to ensure you get the best experience on our website.",
                dismiss: "Got it!",
                link: "Learn more",
                href: window.location.origin + "/cookies-policy"
              }
            });
          }
        });

        var slideout = new Slideout({
          panel: document.getElementById("panel"),
          menu: document.getElementById("slide-out"),
          padding: 320,
          tolerance: 200,
          touch: false
        });

        $(".newsletter form").parsley();

        $(".newsletter form").on("submit", function(e) {
          e.preventDefault();
          const form = $(this);
          form
            .parsley()
            .validate();

          if (
            form
              .parsley()
              .isValid()
          ) {
            const oid = form.find("input[name='oid']").val();
            const retURL = form.find("input[name='retURL']").val();
            const debug = form.find("input[name='debug']").val();
            const lead_source = form.find("input[name='lead_source']").val();
            const debugEmail = form.find("input[name='debugEmail']").val();
            const first_name = form.find("input[name='first_name']").val();
            const last_name = form.find("input[name='last_name']").val();
            const email = form.find("input[name='email']").val();

            $.ajax({
              method: "POST",
              dataType: "json",
              url: ajaxurl,
              data: {
                action: "newsletter",
                oid: oid,
                retURL: retURL,
                debug: debug,
                lead_source: lead_source,
                debugEmail: debugEmail,
                first_name: first_name,
                last_name: last_name,
                email: email
              },
              success: function(response) {
                form.find(".msg-success").text(response.data.success);
                form.find(".msg-success").fadeIn();
                document.cookie = 'hide_contact=true; path=/';
              }
            });
          }
        });

        $(".vacancy .description button").click(function() {
          if (
            $(this)
              .text()
              .trim() === "Read More"
          ) {
            $(this).text("Read Less");
          } else {
            $(this).text("Read More");
          }
          $(this)
            .closest(".description")
            .find(".more")
            .slideToggle();
        });

        $("select").select2();

        $(".hamburger, .close-nav img").click(function() {
          $(".hamburger").toggleClass("is-active");
          $("#slide-out").addClass("open");
          slideout.toggle();
        });

        $("button.search").click(function() {
          $(".flex-wrap .search-flex .contact").hide();
          $(".flex-wrap .search-flex .search-form")
            .fadeIn()
            .css("display", "flex");
        });

        $("button.close-search").click(function() {
          $(".flex-wrap .search-flex .search-form").hide();
          $(".flex-wrap .search-flex .contact").show();
        });

        $("nav#slide-out ul li.menu-item-has-children").each(function() {
          $(this).append('<span class="toggle-sub"></span>');
        });

        $(".toggle-sub").click(function() {
          $(this)
            .prev("ul.sub-menu")
            .slideToggle();
        });

        $(".slider").slick({
          nextArrow: '<button><i class="fa fa-chevron-right"></i></button>',
          prevArrow: '<button><i class="fa fa-chevron-left"></i></button>'
        });

        $("ul.pager li").click(function(e) {
          $("ul.pager li").each(function() {
            $(this).removeClass("active");
          });

          e.preventDefault();

          $(this).addClass("active");

          var slideno = $(this).data("slide");
          $(".slider").slick("slickGoTo", slideno - 1);
        });

        $(".slider").on("beforeChange", function(event, slick, currentSlide, nextSlide) {
          nextSlide = nextSlide + 1;

          $("ul.pager li").each(function() {
            $(this).removeClass("active");
            if ($(this).data("slide") === nextSlide) {
              $(this).addClass("active");
            }
          });
        });

        $(".share-wrap .share i").click(function() {
          $(this)
            .parents()
            .eq(1)
            .children(0)
            .toggleClass("flex");
        });

        $(".image-slider").slick({
          slidesToShow: 1,
          nextArrow: '<button><i class="fa fa-chevron-right"></i></button>',
          prevArrow: '<button><i class="fa fa-chevron-left"></i></button>'
        });

        $("ul.titles li").click(function(e) {
          e.preventDefault();

          var selected = $(this).data("title");
          $("ul.titles li").each(function() {
            if ($(this).data("title") === selected) {
              $(this).addClass("active");
            } else {
              $(this).removeClass("active");
            }
          });
          $("ul.text li").each(function() {
            if ($(this).data("text") === selected) {
              $(this).addClass("active");
            } else {
              $(this).removeClass("active");
            }
          });
        });

        $('input[type="date"]')
          .datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: "dd/mm/yy",
            yearRange: "-100:+00"
          })
          .attr("type", "text")
          .attr("placeholder", "dd/mm/yyyy");

        // Newsletter popup
        $('.contact-popup .close-popup').click(function () {
          $('.contact-popup').removeClass("active");
          $('.contact-popup').fadeOut();
          document.cookie = 'hide_contact=true; path=/';
        });

        function displayPopup() {
          if ($(window).scrollTop() + $(window).height() > $('footer.content-info').offset().top) {
            $('.contact-popup.active').fadeOut();
          } else {
            $('.contact-popup.active').fadeIn();
          }
        }

        $(window).on('scroll load', function () {
          displayPopup();
        });


        /**
         * On Click change text below shields
         */
        if($('section.pride-shields-block').length > 0){
          var shields = $('section.pride-shields-block a');
          $(shields).click(function(e){
            e.preventDefault();
            $(shields).removeClass('active');
            $(this).addClass('active');

            var title = $(this).data('title');
            var text = $(this).data('text');

            $('section.pride-shields-block h4').text(title);
            $('section.pride-shields-block p').text(text);
          });
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    home: {
      init: function() {
        $("#homeCarousel").slick({
          dots: false,
          arrows: false,
          infinite: true,
          speed: 1000,
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 12000
        });

        video = document.querySelector("#panelVideo");
        var playPause = document.getElementById("play-pause");
        icon = playPause.querySelectorAll("i");

        playPause.addEventListener("click", function() {
          if (video.paused === true) {
            video.play();
            icon[0].classList.remove("fa-play");
            icon[0].classList.add("fa-pause");
          } else {
            video.pause();
            icon[0].classList.remove("fa-pause");
            icon[0].classList.add("fa-play");
          }
        });

        if ($(".slick-active").find("video").length > 0) {
          $("#slideVideo").trigger("play");
          $("#slideVideo").attr("loop", "loop");
          $(".play-button").css("visibility", "visible");
        }

        $("#homeCarousel").on("afterChange", function(event, slick, currentSlide) {
          document.querySelector("#slideVideo").currentTime = 0;
          if ($(".slick-active").find("video").length > 0) {
            $("#homeCarousel").slick("slickPause");
            $("#slideVideo").trigger("play");
            $(".play-button").css("visibility", "visible");
          } else {
            $(".play-button").css("visibility", "hidden");
            $("#slideVideo").trigger("pause");
          }
        });

        $("#slideVideo").on("ended", function() {
          $("#slideVideo").trigger("pause");
          $("#homeCarousel").slick("slickPlay");
          $("#homeCarousel").slick("slickNext");
        });

        var padding = 60;
        $(".slick-slide").each(function(index) {
          $(this)
            .find(".slide-content")
            .css(
              "top",
              $(".shield-content").offset().top -
                $(this)
                  .find(".slide-content-wrap")
                  .height() -
                padding
            );
        });

        if ($(window).width() < 768) {
          $(".slide-content").css("top", "45vh");
        } else if ($(window).width() < 992) {
          $(".slide-content").css("top", "40vh");
        }

        $(window).on("resize", function() {
          $(".slick-slide").each(function(index) {
            $(this)
              .find(".slide-content")
              .css(
                "top",
                $(".shield-content").offset().top -
                  $(this)
                    .find(".slide-content-wrap")
                    .height() -
                  padding
              );
          });

          if ($(window).width() < 768) {
            $(".slide-content").css("top", "45vh");
          } else if ($(window).width() < 992) {
            $(".slide-content").css("top", "40vh");
          }
        });

        $(".down").click(function() {
          $("html, body").animate(
            {
              scrollTop: $("#scroll").offset().top
            },
            1000
          );
        });

        var playButton = {
          el: document.querySelector(".play-button"),

          states: {
            paused: {
              nextState: "playing",
              iconEl: document.querySelector("#pause-icon")
            },
            playing: {
              nextState: "paused",
              iconEl: document.querySelector("#play-icon")
            }
          },

          animationDuration: 350,

          init: function() {
            this.setInitialState();
            this.replaceUseEl();
            this.el.addEventListener("click", this.goToNextState.bind(this));
          },

          setInitialState: function() {
            var initialIconRef = this.el.querySelector("use").getAttribute("xlink:href");
            var stateName = this.el.querySelector(initialIconRef).getAttribute("data-state");
            this.setState(stateName);
          },

          replaceUseEl: function() {
            d3.select(this.el.querySelector("use")).remove();
            d3.select(this.el.querySelector("svg"))
              .append("path")
              .attr("class", "js-icon")
              .attr("d", this.stateIconPath());
          },

          goToNextState: function() {
            this.setState(this.state.nextState);

            if (this.state.nextState === "paused") {
              document.querySelector("#slideVideo").pause();
            } else {
              document.querySelector("#slideVideo").play();
            }

            d3.select(this.el.querySelector(".js-icon"))
              .transition()
              .duration(this.animationDuration)
              .attr("d", this.stateIconPath());
          },

          setState: function(stateName) {
            this.state = this.states[stateName];
          },

          stateIconPath: function() {
            return this.state.iconEl.getAttribute("d");
          }
        };

        playButton.init();

        $("#locationSearch").click(function() {
          var postcode = $("#postcode").val();
          var category = 'military-preparation-college';
          var page = 'homepage';

          if (postcode.length > 0) {
            $(".lookup label").removeClass("error");

            $.ajax({
              method: "POST",
              url: ajaxurl,
              dataType: "json",
              data: {
                action: "postcode_lookup",
                postcode: postcode,
                category: category,
                page: page,
              },

              success: function(response) {
                response = response.data;
                if (response.action === "redirect") {
                  window.location.href = response.page;
                }
              }
            });
          } else {
            $(".lookup label").addClass("error");
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    page_template_template_toggle: {
      init: function() {
        $(".toggle h2.title").click(function() {
          $(this).toggleClass("active");
          $(this)
            .children()
            .eq(0)
            .toggleClass("rotate");
          $(this)
            .parent()
            .children()
            .eq(1)
            .slideToggle();
        });
      },
      finalize: function() {}
    },
    page_template_template_landing_page: {
      init: function() {

        // Return true if in view
        function isScrolledIntoView(elem) {
          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();

          var elemTop = $(elem).offset().top;
          var elemBottom = elemTop + $(elem).height();

          return elemTop <= docViewBottom && elemBottom >= docViewTop;
        }

        $(window).on('load scroll', function() {
          const progressBar = $('.progress-bar');
          if (!progressBar.hasClass('active') && isScrolledIntoView(progressBar)) {
            const progressValue = progressBar.attr('aria-valuenow');
            progressBar.addClass('active');
            $('.progress-bar').animate(
              {
                width: progressValue + '%',
              }
            );
          }
        });

        $('.leader-board-block ul a').click(function(e){
          e.preventDefault();
          $('.leader-board-block ul a').removeClass('active');
          $(this).addClass('active');
          var section = $(this).data('section');
          var bib = $(this).data('bib');

          if(!bib) {
            console.log('no bib');
            $('.leader-board-block table tr.bibs').addClass('hide-bibs');
          }else {
            $('.leader-board-block table tr.bibs').removeClass('hide-bibs');
          }

          $('.leader-board-block table tr').removeClass('active');

          $('.leader-board-block table tr').each(function(){
            if($(this).data('section') === section){
              $(this).addClass('active');
            }
          });
        });

      },
      finalize: function() {}
    },
    page_template_template_people: {
      init: function() {
        $("button.more-info").click(function() {
          var languageCode = $("html").attr("lang");
          if (languageCode === "cy-GB") {
            if (
              $(this)
                .text()
                .trim() === "RHAGOR O WYBODAETH"
            ) {
              $(this).text("LLAI O WYBODAETH");
            } else {
              $(this).text("RHAGOR O WYBODAETH");
            }
          } else {
            if (
              $(this)
                .text()
                .trim() === "More Info"
            ) {
              $(this).text("Less Info");
            } else {
              $(this).text("More Info");
            }
          }

          $(this)
            .parents()
            .eq(2)
            .children()
            .eq(1)
            .slideToggle();
        });
      },
      finalize: function() {}
    },
    single_location: {
      init: function() {
        $("button").click(function() {
          var languageCode = $("html").attr("lang");
          if (languageCode === "cy-GB") {
            if (
              $(this)
                .text()
                .trim() === "RHAGOR O WYBODAETH"
            ) {
              $(this).text("LLAI O WYBODAETH");
            } else {
              $(this).text("RHAGOR O WYBODAETH");
            }
          } else {
            if (
              $(this)
                .text()
                .trim() === "More Info"
            ) {
              $(this).text("Less Info");
            } else {
              $(this).text("More Info");
            }
          }

          $(this)
            .parents()
            .eq(2)
            .children()
            .eq(1)
            .slideToggle();
        });
      },
      finalize: function() {}
    },
    single_staff_members: {
      init: function() {
        $(".staff-members-row").each(function() {
          var row = $(this);
          row.find(".staff-member-image").click(function() {
            var id = $(this).attr("id");
            var activeMember = row.find(".member-active");
            var member;
            if (activeMember.length > 0) {
              if (activeMember.attr("id") === id) {
                activeMember.slideUp();
                activeMember.removeClass("member-active");
              } else {
                activeMember.hide();
                activeMember.removeClass("member-active");
                member = row.find(".staff-member-content #" + id);
                member.show();
                member.addClass("member-active");
              }
            } else {
              member = row.find(".staff-member-content #" + id);
              member.slideToggle();
              member.addClass("member-active");
            }
          });
        });
      },
      finalize: function() {}
    },
    locations: {
      init: function() {
        $("#location").change(function() {
          window.location.href = $(this).val();
        });

        $("#postcodeSubmit").click(function() {
          var postcode = $("input[name=postcode]").val();
          var category = $(this).data("category");

          if (postcode.length > 0) {
            $(".lookup label").removeClass("error");

            $.ajax({
              method: "POST",
              url: ajaxurl,
              dataType: "json",
              data: {
                action: "postcode_lookup",
                postcode: postcode,
                category: category
              },

              beforeSend: function() {
                $("#postcodeSubmit").html('<i class="fa fa-spinner fa-pulse"></i>');
              },

              success: function(response) {
                $("#postcodeSubmit").html("Go");
                response = response.data;
                if (response.action === "redirect") {
                  window.location.href = response.page;
                }
                if (response.action === "filter") {
                  $(".location-list li").each(function() {
                    $(this).show();
                    if ($(this).data("filter") !== response.postcode) {
                      $(this).fadeOut();
                    }
                  });
                }
              }
            });
          } else {
            $(".lookup label").addClass("error");
          }
        });
      },
      finalize: function() {}
    },
    // About us page, note the change from about-us to about_us.
    league_tables: {
      init: function() {
        $("button#show-more").click(function() {
          if ($(this).text() === "Show More") {
            $(this).text("Show Less");
          } else {
            $(this).text("Show More");
          }

          var toggle = $(this)
            .closest("section")
            .find(".expand");
          toggle.slideToggle();
        });

        $("button#show-more-section").click(function() {
          if ($(this).text() === "Show More") {
            $(this).text("Show Less");
          } else {
            $(this).text("Show More");
          }

          var toggle = $(this)
            .parents()
            .eq(1)
            .children()
            .eq(2);
          toggle.slideToggle();
        });
      }
    },

    apply_now: {
      init: function() {

        $("#form-select a").click(function(e){
          e.preventDefault();

          $("#form-select a").removeClass('active');
          $(this).addClass('active');

          var form = $(this).data('form');

          $("#apply-now").trigger("reset");
          $('select[name=00N0O00000GNH7Z]').prop('selectedIndex',0);
          $('select[name=centreCollage]').prop('selectedIndex',0);
          $('select[name=centreSports]').prop('selectedIndex',0);

          $("select").select2("destroy");
          $("select").select2();

          $('input[name="formType"]').val(form);

          if(form === "General"){
            $('.general').removeClass('d-none');
            $('.enrolment').addClass('d-none');
            $('.collage-field').addClass('d-none');
            $('.sports-field').addClass('d-none');
            $('#form-text').empty();
          }

          if(form === "Enrolment"){
            $('.both').removeClass('d-none');
            $('.enrolment').removeClass('d-none');
          }

          var title = $(this).data('text');

          $('.content-wrap h2').text(title);

          $('html, body').animate({
            scrollTop: $("#scroll").offset().top
        }, 750);

      });

        $('#dob').mask('00/00/0000');

        $('.shields-lg a').click(function (e) {

          e.preventDefault();
          $('#success-popup .inner').empty();
          var id = $('input[name=area]').val();

          $('.shields-lg a img').addClass('fade');
          $(this).find("img").removeClass('fade');

          var academy = $(this).data('academy');

          $('input[name=academy]').val(academy);

          $.ajax({
            method: "POST",
            dataType: "json",
            url: ajaxurl,
            data: {
              action: "get_form_text",
              section: academy,
              id: id,
            },

            success: function(response) {
              content = response.data.content;
              $('#form-text').empty();
              $('#form-text').append(content);
            }

          });

          if(academy === "military-preperation-college"){

            $('.collage-field').removeClass('d-none');

            if(!$('.sports-field').hasClass('d-none')){
              $('.sports-field').addClass('d-none');
            }

            var select = $('select[name=date]');
            select.attr('disabled', true);
            select.find('option').not(':first').remove();

            $.ajax({
              method: "POST",
              dataType: "json",
              url: ajaxurl,
              data: {
                action: "get_open_day_dates",
              },
              success: function(response) {
                var dates = response.data.dates;
                var options = "";
                for(var i = 0; i < dates.length; i++){
                  options += "<option value=\"" + dates[i].id + "\">" + dates[i].title + "</option>";
                }

                select.append(options);
                select.attr('disabled', false);
              }
            });

          }

            if(academy === "sports-exercise-college"){

              if(!$('.collage-field').hasClass('d-none')){
                $('.collage-field').addClass('d-none');
              }

              $('.sports-field').removeClass('d-none');

            }

          if(academy === "military-preperation-school" || academy === "sports-apprenticeship"){

              if(!$(".collage-field").hasClass('d-none')){
                $('.collage-field').addClass('d-none');
              }

              if(!$(".sports-field").hasClass('d-none')){
                $('.sports-field').addClass('d-none');
              }

            }
        });


        /**
         * Get available open day dates and populate select options
         * @param {*} openDay
         */
        $(document).on("change", "select[name=open-day]", function () {
          var select = $('select[name=date]');
          select.attr('disabled', true);
          select.find('option').not(':first').remove();

          $.ajax({
            method: "POST",
            dataType: "json",
            url: ajaxurl,
            data: {
              action: "get_open_day_dates",
              openDay: $(this).val(),
            },
            success: function(response) {
              var dates = response.data.dates;
              var options = "";
              for(var i = 0; i < dates.length; i++){
                options += "<option value=\"" + dates[i].id + "\">" + dates[i].title + "</option>";
              }

              select.append(options);
              select.attr('disabled', false);
            }
          });
        });

        $('#apply-now').submit(function(e) {

          e.preventDefault();

          $('.error').addClass('d-none');

          var response = grecaptcha.getResponse();
          if(response.length === 0) {
            $('#recaptcha-error').removeClass('d-none');
            return false;
          }


        var ppc = false;
        var campaignAd = null;
        var campaign = null;
        var retURL = $('input[name=retURL]').val();
        var area = $('input[name=area]').val();
        var firstname = $('input[name=first_name]').val();
        var lastname = $('input[name=last_name]').val();
        var interested = $('select[name=00N0O00000GNH7Z]').val();
        var email = $('input[name=email]').val();
        var mobile = $('input[name=mobile]').val();
        var openday = ($('input[name=open-day]').length > 0 ? $('input[name=open-day]').val() : $('select[name=open-day]').val());
        var date = $('select[name=date]').val();
        var message = $('textarea[name=00N20000008dM8R]').val();
        var dob = $('input[name=dob]').val();
        var centre = $('select[name=centre]').val();
        var centreCollage = $('select[name=centreCollage]').val();
        var centreSports = $('select[name=centreSports]').val();
        var academy = $('.academy-field').val();
        var formType = $('input[name=formType]').val();

        if(window.sessionStorage && window.sessionStorage.getItem('source')){
          ppc = true;
          var source = sessionStorage.source;
          campaignAd = sessionStorage.content + '_' + source;
        }

        if(window.sessionStorage && window.sessionStorage.getItem('medium')){
          ppc = true;
          var medium = sessionStorage.medium;
        }

        if(window.sessionStorage && window.sessionStorage.getItem('content')){
          ppc = true;
          var content = sessionStorage.content;
        }

        if(window.sessionStorage && window.sessionStorage.getItem('campaign')){
          ppc = true;
          var campaign = sessionStorage.campaign;
        }

        if(dob){

          var now = moment().startOf('day');

          var dobArray = dob.split('/');

          var d = moment([dobArray[2], dobArray[1], dobArray[0]]);

          var age = now.diff(d, 'years');

        }else{
          age = 0;
        }

        if(formType === "Enrolment" && academy === ""){
          $('#academy-error').removeClass('d-none');
          return false;
        }

        if(formType === "Enrolment" && dob === ""){
          $('#dob-error').removeClass('d-none');
          $('html, body').animate({
            scrollTop: $("#scroll").offset().top
          }, 750);
          return false;
        }

        $.ajax({
          method: "POST",
          dataType: "json",
          url: ajaxurl,
          data: {
            action: "appy_now_submit",
            retURL: retURL,
            firstname: firstname,
            lastname: lastname,
            interested: interested,
            email: email,
            mobile: mobile,
            openday: openday,
            date: date,
            message: message,
            area: area,
            dob: dob,
            centre: centre,
            centreCollage: centreCollage,
            centreSports: centreSports,
            academy: academy,
            formType: formType,
            campaignName: campaign,
            campaignAd: campaignAd,
          },
            success: function(response) {

              if(formType === "Enrolment" && ppc === true){
                ga("send", "event", campaign, "application", source + "_" + content, 1);
              }

                if(formType === "Enrolment" && academy === "military-preperation-college"){
                  if(age >= 16 && age <=18){
                    $('#success-popup').append("<h3>Congratulations on enrolling at MPCT.</h3> You will receive your login details for MPCT’s VLE/LMS within the next 24 hours.</p>");
                  }else{
                    $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");
                  }
                }

                if(formType === "Enrolment" && academy === "sports-exercise-college"){
                  if(age >= 16 && age <=18){
                    $('#success-popup').append("<h3>Congratulations on enrolling at MPCT.</h3> You will receive your login details for MPCT’s VLE/LMS within the next 24 hours.</p>");
                  }else{
                    $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");
                  }
                }

                if(formType === "Enrolment" && academy === "military-preperation-school"){
                  $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");
                }

                if(formType === "Enrolment" && academy === "sports-apprenticeship"){
                  $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");
                }

                if(formType === "General"){
                  $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");
                }

                $.magnificPopup.open({
                  items: {
                      src: '#success-popup'
                  },
                  type: 'inline',
                  callbacks: {
                    close: function(){
                      if(formType === "Enrolment" && ppc === true){
                        reload = window.location.href + "?submit=true&utm_source=" + source + "&utm_medium=" + medium + "&utm_campaign=" + campaign + "&utm_content=" + content;
                        window.location.href = reload;
                      }else{
                        reload = window.location.href + "?submit=true";
                        window.location.href = reload;
                      }
                    },
                  }
                });

                setTimeout(function(){
                  $.magnificPopup.close({
                    items: {
                      src: '#success-popup',
                      },
                    });
                }, 2000);

            },
            error: function(response) {

              if(formType === "Enrolment" && ppc === true){
                ga("send", "event", campaign, "application", source + "_" + content, 1);
              }

              if(formType === "Enrolment" && academy === "military-preperation-college"){
                if(age >= 16 && age <=18){
                  $('#success-popup').append("<h3>Congratulations on enrolling at MPCT.</h3> You will receive your login details for MPCT’s VLE/LMS within the next 24 hours.</p>");
                }else{
                  $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");
                }
              }

              if(formType === "Enrolment" && academy === "sports-exercise-college"){
                if(age >= 16 && age <=18){
                  $('#success-popup').append("<h3>Congratulations on enrolling at MPCT.</h3> You will receive your login details for MPCT’s VLE/LMS within the next 24 hours.</p>");
                }else{
                  $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");
                }
              }

              if(formType === "Enrolment" && academy === "military-preperation-school"){
                $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");
              }

              if(formType === "Enrolment" && academy === "sports-apprenticeship"){
                $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");
              }

              if(formType === "General"){
                $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");
              }

              $.magnificPopup.open({
                items: {
                    src: '#success-popup'
                },
                type: 'inline',
                callbacks: {
                  close: function(){
                    if(formType === "Enrolment" && ppc === true){
                      reload = window.location.href + "?submit=true&utm_source=" + source + "&utm_medium=" + medium + "&utm_campaign=" + campaign + "&utm_content=" + content;
                      window.location.href = reload;
                    }else{
                      reload = window.location.href + "?submit=true";
                      window.location.href = reload;
                    }
                  },
                }
              });
              setTimeout(function(){
                $.magnificPopup.close({
                  items: {
                    src: '#success-popup',
                    },
                  });
              }, 2000);
            },
          });
        });
      }
    },
    contact_us: {
      init: function() {
        $('#apply-now').submit(function(e) {

          e.preventDefault();

          var response = grecaptcha.getResponse();
          if(response.length === 0) {
            $('#recaptcha-error').removeClass('d-none');
            return false;
          }

        var retURL = $('input[name=retURL]').val();
        var area = $('input[name=area]').val();
        var firstname = $('input[name=first_name]').val();
        var lastname = $('input[name=last_name]').val();
        var interested = $('select[name=00N0O00000GNH7Z]').val();
        var email = $('input[name=email]').val();
        var mobile = $('input[name=mobile]').val();
        var openday = ($('input[name=open-day]').length > 0 ? $('input[name=open-day]').val() : $('select[name=open-day]').val());
        var date = $('select[name=date]').val();
        var message = $('textarea[name=00N20000008dM8R]').val();
        var dob = $('input[name=dob]').val();
        var centre = $('select[name=centre]').val();
        var academy = $('.academy-field').val();
        var formType = $('input[name=formType]').val();

        $.ajax({
          method: "POST",
          dataType: "json",
          url: ajaxurl,
          data: {
            action: "appy_now_submit",
            retURL: retURL,
            firstname: firstname,
            lastname: lastname,
            interested: interested,
            email: email,
            mobile: mobile,
            openday: openday,
            date: date,
            message: message,
            area: area,
            dob: dob,
            centre: centre,
            academy: academy,
            formType: formType
          },
            success: function(response) {

                $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");

                $.magnificPopup.open({
                  items: {
                      src: '#success-popup'
                  },
                  type: 'inline',
                  callbacks: {
                    close: function(){
                      reload = window.location.href + "?submit=true";
                      window.location.href = reload;
                    },
                  }
                });

                setTimeout(function(){
                  $.magnificPopup.close({
                    items: {
                      src: '#success-popup',
                      },
                    });
                }, 2000);

            },
            error: function(response) {

              $('#success-popup').append("<h3>Thank you for your enquiry.</h3><p>A member of the MPCT team will contact you by phone or email.</p>");

              $.magnificPopup.open({
                items: {
                    src: '#success-popup'
                },
                type: 'inline',
                callbacks: {
                  close: function(){
                    reload = window.location.href + "?submit=true";
                    window.location.href = reload;
                  },
                }
              });

              setTimeout(function(){
                $.magnificPopup.close({
                  items: {
                    src: '#success-popup',
                    },
                  });
              }, 2000);

            },
          });
        });
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
